import './Pdftopowerpoint.css';
let Pdftopowerpoint=()=>{
    let inputhandle=(e)=>{
        let file = e.target.files[0]
        
    }
    return(
        <div className='conpdfpoewrmaincont'>
            <h2 className='conpdfpowerhead'>Convert Pdf to Powerpoint</h2>
            <div className='inputcont'>
                <label onClick={()=>{alert("This Service available soon...")}} className='pdftopowerlabel' htmlFor='inputpd'>Choose pdf</label>
                <input id='inputpdf' style={{display:"none"}} type='file' accept="application/pdf" onChange={inputhandle}/>
            </div>
        </div>
    ); 
}
export default Pdftopowerpoint;